import { Injectable, Injector } from '@angular/core';
import { DaoBaseService } from './dao-base.service';
import { Tenant } from '../models/tenant.model';
import { TipoCapacidade } from '../models/tipo-capacidade.model';
import { LookupItem } from '../services/lookup.service';

export type CertificateKeys = {
  public_key: string,
  private_key: string
}

export type TipoDados = 'tiposIntegracao' | 'rotinas' | 'frequencias';
export type TipoFrequencia = 'daily' | 'dailyAt';

export type InitialData = {
  tiposIntegracao?: LookupItem[],
  rotinas?: LookupItem[],
  frequencias?: LookupItem[],
};

export type Rotina = {
  ativa: boolean,
  classe: string,
  horario: string,
  frequencia: TipoFrequencia
}

export type LogoItem = {
  theme: string,
  file: string
};

@Injectable({
  providedIn: 'root'
})
export class TenantDaoService extends DaoBaseService<Tenant> {
  public PREFIX_URL: string = "config";

  constructor(protected injector: Injector) {
    super("Tenant", injector);
  }

  public deleteTenant(item: TipoCapacidade) {
    return new Promise<boolean>((resolve, reject) => {
      this.server.post('config/' + this.collection + '/delete-tenant', {
        tenant_id: item.id,
      }).subscribe(response => {
        if (response.error) {
          reject(response.error);
        } else {
          resolve(!!response?.success);
        }
      }, error => reject(error));
    });
  }

  public runMigrations(tenantId: string) {
    return new Promise<boolean>((resolve, reject) => {
      this.server.post('config/' + this.collection + '/run-migrations', {
        tenant_id: tenantId,
      }).subscribe(response => {
        if (response.error) {
          reject(response.error);
        } else {
          resolve(!!response?.success);
        }
      }, error => reject(error));
    });
  }

  public obterDados(tenantId: string, dados: string[]): Promise<InitialData> {
    return new Promise<InitialData>((resolve, reject) => {
      try {
        this.server.post(this.PREFIX_URL + '/' + this.collection + '/obter-dados', { tenant_id: tenantId, dados: dados }).subscribe(
          (response) => {
            if (response.error) {
              reject(response.error);
            } else {
              let result: InitialData = {};
              let obterLookups = (dados: { key: any; value: any; }[]) => {
                let lookupItems: LookupItem[] = [];
                dados.forEach(x => lookupItems.push(Object.assign({}, { key: x.key, value: x.value })));
                return lookupItems;
              }
              Object.entries(response.data).forEach(([dado, value]) => {
                switch (dado) {
                  case 'tiposIntegracao': result.tiposIntegracao = obterLookups(value as { key: any; value: any; }[]); break;
                  case 'rotinas': result.rotinas = obterLookups(value as { key: any; value: any; }[]); break;
                  case 'frequencias': result.frequencias = obterLookups(value as { key: any; value: any; }[]); break;
                }
              })
              resolve(result);
            }
          },
          (error) => reject(error)
        );
      } catch (error) {
        reject(error);
      }
    });
  }

  public obterPerfisSiglas(): Promise<{ perfis: LookupItem[], siglas: string[] }> {
    return new Promise<{ perfis: LookupItem[], siglas: string[] }>((resolve, reject) => {
      try {
        this.server.get(this.PREFIX_URL + '/' + this.collection + '/obter-perfis-siglas').subscribe((response) => {
          if (response.error) {
            reject(response.error);
          } else {
            let lookupItems: LookupItem[] = [];
            response.data.perfis.forEach((x: string) => lookupItems.push(Object.assign({}, { key: x, value: x }) as LookupItem));
            resolve({ perfis: lookupItems, siglas: response.data.siglas });
          }
        }, (error) => reject(error));
      } catch (error) {
        reject(error);
      }
    });
  }

  public generateCertificateKeys() {
    return new Promise<CertificateKeys>((resolve, reject) => {
      this.server.post('config/' + this.collection + '/generate-certificate-keys', {}).subscribe(response => {
        if (response.error) {
          reject(response.error);
        } else {
          resolve(response.data);
        }
      }, error => reject(error));
    });
  }

  /* public cidadesSeeder(item: Cidade) {
    return new Promise<boolean>((resolve, reject) => {
      this.server.post('config/' + this.collection + '/cidades', {
        tenant_id: item.id
      }).subscribe(response => {
        if (response.error) {
          reject(response.error);
        } else {
          resolve(!!response?.success);
        }
      }, error => reject(error));
    });
  }

  public tiposCapacidadesSeeder(item: TipoCapacidade) {
    return new Promise<boolean>((resolve, reject) => {
      this.server.post('config/' + this.collection + '/tipo-capacidade', {
        tenant_id: item.id,
      }).subscribe(response => {
        if (response.error) {
          reject(response.error);
        } else {
          resolve(!!response?.success);
        }
      }, error => reject(error));
    });
  }
 */

  /*   

  public seeders(item: TipoCapacidade) {
    return new Promise<boolean>((resolve, reject) => {
      this.server.post('config/' + this.collection + '/seeders', {
        tenant_id: item.id,
      }).subscribe(response => {
        if (response.error) {
          reject(response.error);
        } else {
          resolve(!!response?.success);
        }
      }, error => reject(error));
    });
  } */
  /*   public resetDb() {
    return new Promise<boolean>((resolve, reject) => {
      this.server.get('config/' + this.collection + '/reset-db').subscribe(response => {
        if (response.error) {
          reject(response.error);
        } else {
          resolve(!!response?.success);
        }
      }, error => reject(error));
    });
  }
  public usuarioSeeder(item: Cidade) {
    return new Promise<boolean>((resolve, reject) => {
      this.server.post('config/' + this.collection + '/cidades', {
        tenant_id: item.id
      }).subscribe(response => {
        if (response.error) {
          reject(response.error);
        } else {
          resolve(!!response?.success);
        }
      }, error => reject(error));
    });
  }

  public entidadeSeeder(item: Cidade) {
    return new Promise<boolean>((resolve, reject) => {
      this.server.post('config/' + this.collection + '/cidades', {
        tenant_id: item.id
      }).subscribe(response => {
        if (response.error) {
          reject(response.error);
        } else {
          resolve(!!response?.success);
        }
      }, error => reject(error));
    });
  } */

  /*   public databaseSeeder(item: Cidade) {
      return new Promise<boolean>((resolve, reject) => {
        this.server.post('config/' + this.collection + '/database', {
          tenant_id: item.id
        }).subscribe(response => {
          if (response.error) {
            reject(response.error);
          } else {
            resolve(!!response?.success);
          }
        }, error => reject(error));
      });
    } */
}

